"use client"

import { WifiSync } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WifiSyncIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WifiSyncIcon = component(Icon)({ as: WifiSync })
